import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=51ac5db2&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"
import style0 from "./conversation.vue?vue&type=style&index=0&id=51ac5db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac5db2",
  null
  
)

export default component.exports